import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, AfterViewInit, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./search-input.component.scss']
})
export class SearchInputComponent implements AfterViewInit, OnChanges {
  @Input() placeholder: string = 'Search...';
  @Input() value: string = '';
  @Output() valueChange = new EventEmitter<string>();
  @Input() icon: string = 'search';
  @ViewChild('searchInput') searchInput!: ElementRef<HTMLInputElement>;

  ngAfterViewInit() {
    if (this.searchInput && this.value) {
      this.searchInput.nativeElement.value = this.value;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['value'] && this.searchInput) {
      const newValue = changes['value'].currentValue || '';
      if (this.searchInput.nativeElement.value !== newValue) {
        const cursorPos = this.searchInput.nativeElement.selectionStart;
        this.searchInput.nativeElement.value = newValue;
        if (cursorPos !== null) {
          this.searchInput.nativeElement.setSelectionRange(cursorPos, cursorPos);
        }
      }
    }
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input?.value !== undefined) {
      this.value = input.value;
      this.valueChange.emit(input.value);
    }
  }

  focus() {
    if (this.searchInput) {
      this.searchInput.nativeElement.focus();
    }
  }
}